// An output whose file the bucket no longer keeps (spec generation/expired-outputs): the API says
// so (`GenerationOutput.expired`, no URL) and gives the days (`Job.output_days`); the web decides
// neither.
import type { GenerationOutput, Job } from "../../api/generated/model";
import { countOf } from "../../ui/format";

/** A delivered output past its days and not saved: it has no file to show or act on. */
export function isExpired(output: GenerationOutput): boolean {
  return output.status === "delivered" && output.expired === true;
}

/** Daniil's words for it (2026-11-03): "Not saved: deleted after 7 days", the days the API's. */
export function expiredLine(job: Job): string {
  return job.output_days === undefined
    ? "Not saved: deleted"
    : `Not saved: deleted after ${countOf(job.output_days, "day")}`;
}
